<script setup>
import { reactive, ref, onMounted, computed } from 'vue';
import { useAuthStore } from '@/stores/auth';

const authStore = useAuthStore();

const isLoggedIn = computed(() => {
	return authStore.isLoggedIn;
});

const image = computed(() => {
	return authStore.image;
});

const initials = computed(() => {
	return authStore.initials;
});
</script>

<template>
	<div v-if="isLoggedIn">
		<img class="avatar-image" v-if="image" :src="image"/>
		<span v-else class="avatar-initials" v-html="initials"></span>
	</div>
	<svg v-else width="13" height="15" viewBox="0 0 13 15" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M8.75 4.25C8.75 3.32031 8.23047 2.47266 7.4375 1.98047C6.61719 1.51562 5.60547 1.51562 4.8125 1.98047C3.99219 2.47266 3.5 3.32031 3.5 4.25C3.5 5.20703 3.99219 6.05469 4.8125 6.54688C5.60547 7.01172 6.61719 7.01172 7.4375 6.54688C8.23047 6.05469 8.75 5.20703 8.75 4.25ZM2.625 4.25C2.625 3.01953 3.28125 1.87109 4.375 1.24219C5.44141 0.613281 6.78125 0.613281 7.875 1.24219C8.94141 1.87109 9.625 3.01953 9.625 4.25C9.625 5.50781 8.94141 6.65625 7.875 7.28516C6.78125 7.91406 5.44141 7.91406 4.375 7.28516C3.28125 6.65625 2.625 5.50781 2.625 4.25ZM0.875 13.875H11.375C11.3203 11.7148 9.54297 9.9375 7.35547 9.9375H4.86719C2.67969 9.9375 0.902344 11.7148 0.875 13.875ZM0 13.957C0 11.25 2.16016 9.0625 4.86719 9.0625H7.35547C10.0625 9.0625 12.25 11.25 12.25 13.957C12.25 14.3945 11.8672 14.75 11.4297 14.75H0.792969C0.355469 14.75 0 14.3945 0 13.957Z" fill="currentColor"/>
	</svg>
</template>
